import React from "react";
import ReactDOM from "react-dom/client";
import { HelmetProvider } from "react-helmet-async";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";

const root = ReactDOM.createRoot(document.getElementById("root"));
const RootWrapper = process.env.NODE_ENV === "development" ? React.Fragment : React.StrictMode;
root.render(
  <RootWrapper>
    <HelmetProvider>
      <App />
    </HelmetProvider>
  </RootWrapper>
);

reportWebVitals();
